import ScratchCard from "./Components/scratchCard.js";
import { useLoaderData, useParams, useSearchParams } from "react-router-dom";
import RemoveCanvasButton from "./Components/RemoveCanvasButton";
import VoteButton from "./Components/VoteButton.js";
import DateBrowser from "./Components/DateBrowser.js";


const NFLHomePage = () => {

    const data = useLoaderData();
    const gameData = data.internalData;
    const sport= "nfl";

    const { date } = useParams();
    const [searchParams]= useSearchParams();
    const timezone = searchParams.get('tz') ?? Intl.DateTimeFormat().resolvedOptions().timeZone;



    return (
    <>
    <div className="sports-page">
      <h1>National Football League Scoreboard</h1>
      <DateBrowser date={date} sport={sport} timezone={timezone}/>
      <RemoveCanvasButton />
      {data.message && <h2>{data.message}</h2>}
      {data.externalData.map(
        ({  id, tournamentName, awayTeam, awayScore, homeTeam, homeScore, startTimestamp, status, homeRecord, awayRecord, venue}) => {

          const gameVotes = gameData.find(vote => vote.eventID === id);

          const watchWorthyScore = (Math.abs(awayScore - homeScore) <=7 && (awayScore + homeScore) >=20)? 1 : 0 ;
          console.log(watchWorthyScore);


          return (
            <div className="game-grid">
            <section key={id} className="game-container">
           <div className="teams-row">
                <div className="away-team">
                  <h2>{awayTeam}</h2>
                  <p>{tournamentName === "NFL" && `(${awayRecord.wins}-${awayRecord.losses})`}</p>
                </div>  
                <h1>@</h1>
                <div className="home-team">
                  <h2>{homeTeam}</h2>
                  <p>{tournamentName === "NFL" && `(${homeRecord.wins}-${homeRecord.losses})`}</p>
                </div>  
              </div>
              <h3>Start Time: {new Date(startTimestamp*1000).toLocaleTimeString([], { hour: "numeric", minute: "numeric"})}</h3>
              <h3>{venue}</h3>
              <h3>{status==="AET" ? "After Extra Time" : status  }</h3>

                      <div className="grid-container">
                  
                        <VoteButton eventID={id} gameDate={date} sport={sport} gameVotes={{upvotes: gameVotes?.upvotes || 0, downvotes: gameVotes?.downvotes || 0}} className="element-1"/>
                        <div className="scores-section element-2">
                            <ul className="scratchable">
                              <li>
                                <span>{awayTeam}:</span> 
                                <ScratchCard text={awayScore} watchWorthyScore={watchWorthyScore} />
                              </li>
                    
                              <li>
                                <span>{homeTeam}:</span>
                                <ScratchCard text={homeScore} watchWorthyScore={watchWorthyScore} />
                              </li>
                            </ul>
                          </div>
                          <div className="watchworthy element-3">

                          </div>

                      </div>
            </section>
          </div>
        )}
      )}
     </div> 
    </>
  );
};

export default NFLHomePage;